import { useMemo } from 'react'
import {
  AggregateBySupplierQueryResult,
  OrgUnit,
  useAggregateBySupplierQuery,
} from '../../../graphql/generated'
import { Row } from './supplierPageConstants'

/**
 * Get rows of data aggregated over suppliers.
 *
 * @param params
 * @returns
 */
export function useSupplierRows(params?: {
  selectedYear?: number
  selectedOrgUnit?: OrgUnit['id']
}): {
  rows: Row[]
} & AggregateBySupplierQueryResult {
  const { selectedOrgUnit, selectedYear } = params ?? {}

  const { data, ...rest } = useAggregateBySupplierQuery({
    variables: {
      orgUnitId: selectedOrgUnit,
      year: selectedYear,
    },
  })

  const rows = useMemo<Row[]>(() => {
    return (data?.aggregateBySupplier?.rows ?? []).map<Row>((row) => ({
      id: `${row.supplierId}${row.supplierName}`,
      supplierId: row.supplierId,
      name: row.supplierName,
      co2e: row.kgCO2e,
      co2ePercentage: row.co2ePercentage,
      kr: row.kr,
      krPercentage: row.krPercentage,
      intensity: row.intensity,
    }))
  }, [data?.aggregateBySupplier])

  return { rows, data, ...rest }
}
